import { useMemo } from "react";
import { computeEstimate, deriveSelectedFees, normalizeFees, type Estimate } from "@shared/commission";
import { useCommissionStore, draftTypes } from "../stores/commissionStore";
import { useIntakeCopy } from "../i18n/useIntakeCopy";
import type { IntakeArtist } from "../types";

export function useEstimate(artist: IntakeArtist): Estimate {
  const { c } = useIntakeCopy();
  const s = useCommissionStore();
  const typesKey = draftTypes(s).join("|");
  const { backgroundType, manualFees, usageType, contentRating, deadlineMode } = s;
  const deadline = deadlineMode === "date" ? s.deadline : null;
  return useMemo(() => {
    const fees = normalizeFees(artist.prices, artist.additionalFees);
    const selected = deriveSelectedFees({ fees, manual: manualFees, usage: usageType ?? "personal", rating: contentRating ?? "sfw", deadline });
    return computeEstimate({
      prices: artist.prices, additionalFees: artist.additionalFees,
      characterTypes: typesKey ? typesKey.split("|").filter(Boolean) : [],
      backgroundType, selectedFees: selected, labels: c.fees,
    });
  }, [artist, typesKey, backgroundType, manualFees, usageType, contentRating, deadline, c]);
}
